import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Check } from "lucide-react";
import ProductImage from "@/components/ProductImage";

export default function ProductCard({ product, onAdd }) {
  const [added, setAdded] = useState(false);

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onAdd?.(product);
    setAdded(true);
    setTimeout(() => setAdded(false), 1400);
  };

  return (
    <Link
      to={`/products/${product.id}`}
      className="group relative bg-[#0a0a0a] overflow-hidden block"
    >
      <div className="relative aspect-[4/5] flex items-center justify-center overflow-hidden">
        {/* Subtle radial spotlight */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(60% 55% at 50% 45%, rgba(255,255,255,0.05) 0%, rgba(0,0,0,0) 60%)",
          }}
        />

        {product.tag && (
          <span
            className={`absolute top-3 right-3 z-10 text-[10px] tracking-[0.2em] font-black px-2 py-1 ${
              product.sale ? "bg-[#c60d0d] text-white" : "bg-white text-black"
            }`}
          >
            {product.tag}
          </span>
        )}

        <div className="absolute inset-6 md:inset-8 flex items-center justify-center transition-transform duration-500 group-hover:scale-[1.05]">
          <ProductImage
            src={product.img}
            alt={`${product.color} boxer brief`}
            className="drop-shadow-[0_30px_40px_rgba(0,0,0,0.55)]"
          />
        </div>

        {/* Hover add-to-cart */}
        <button
          onClick={handleAdd}
          className="absolute bottom-3 left-3 right-3 bg-white text-black text-[11px] tracking-[0.2em] font-black uppercase py-3 flex items-center justify-center gap-2 translate-y-[120%] group-hover:translate-y-0 transition-transform duration-300 z-10 hover:bg-[#c60d0d] hover:text-white"
        >
          {added ? (
            <>
              <Check size={14} /> Added
            </>
          ) : (
            <>
              <Plus size={14} /> Add to Cart
            </>
          )}
        </button>
      </div>

      <div className="bg-white p-4 flex items-center justify-between">
        <div>
          <div className="text-[10px] tracking-[0.22em] uppercase text-black/50">{product.color}</div>
          <div className="text-[13px] font-bold text-black mt-0.5 group-hover:text-[#c60d0d] transition-colors">
            {product.name}
          </div>
        </div>
        <div className="text-right">
          {product.compareAt && (
            <div className="text-[11px] text-black/40 line-through leading-none">${product.compareAt}</div>
          )}
          <div className={`text-[16px] font-black ${product.sale ? "text-[#c60d0d]" : "text-black"}`}>
            ${product.price}
          </div>
        </div>
      </div>
    </Link>
  );
}
